"use client";
import { useEffect, useState } from "react";

type Row = Record<string, unknown>;

export default function Dashboard() {
  const [rows, setRows] = useState<Row[]>([]);
  useEffect(() => { fetch("/api/employees").then((r) => r.json()).then((d) => setRows(d.employees ?? [])); }, []);
  const cols = rows[0] ? Object.keys(rows[0]) : [];
  return (
    <div className="wrap">
      <h1>Employees</h1>
      <p style={{ fontSize: 13, color: "#9aa0ab" }}>Loaded from /api/employees - which returns everything, to anyone.</p>
      <div className="card" style={{ overflowX: "auto" }}>
        <table>
          <thead><tr>{cols.map((c) => <th key={c}>{c}</th>)}</tr></thead>
          <tbody>{rows.map((r, i) => <tr key={i}>{cols.map((c) => <td key={c}>{String(r[c])}</td>)}</tr>)}</tbody>
        </table>
      </div>
    </div>
  );
}
